var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19410_245572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79736 6.44597C7.14712 4.59715 9.00881 3.09296 11.2812 2.17477C16.9705 -0.123984 23.3577 2.00915 26.6694 6.95215",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4529 4.05038L27.3142 7.42714L23.9585 7.26764",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54736 27.9497L4.68611 24.5729L8.04175 24.7324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7202 20.1331L23.2111 11.8762C23.2483 11.6829 23.5182 11.6648 23.5808 11.8515L26.0061 20.0688C26.0649 20.2438 26.313 20.2425 26.37 20.0669L28.7125 11.8529C28.7733 11.6656 29.0432 11.6809 29.0825 11.8737L30.6615 20.1331",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95064 12.4444C7.27377 11.9873 6.45776 11.7204 5.57945 11.7204C3.2372 11.7204 1.33838 13.6185 1.33838 15.9599C1.33838 18.3012 3.23713 20.1993 5.57945 20.1993C6.5307 20.1993 7.3132 19.8862 7.90708 19.3576C8.02995 19.2482 8.14477 19.1296 8.25127 19.0026",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6362 16.233L17.1992 20.2797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7806 16.2177C12.7806 16.2177 14.2443 16.2079 14.87 16.2079C16.1317 16.2079 17.1992 15.2214 17.1992 14.0044C17.1992 12.7874 16.1317 11.8008 14.87 11.8008C14.1307 11.8008 12.616 11.8008 12.616 11.8008H12.6133V20.2796",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33057 25.0479C7.92163 28.9153 12.3953 31.0625 16.9444 30.713",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9204 28.6753C24.2151 27.8279 25.3187 26.7649 26.2027 25.5541",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19410_245572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmIcon);
export default __webpack_public_path__ + "static/media/crmIcon.944715707796d4026505feacd3e227d8.svg";
export { ForwardRef as ReactComponent };